// 日期      版本      維護人員     修改原因
// 20220830  v01.00    Jasper       初版
// 20220908  v02.00    Jasper       支援WIN 與 MAC
// 20220912  v03.00    Jasper       增加 DecryptPdf、ShowPdf、SavePdf、DeletePdf
// 20220919  v04.00    Jasper       調整版號判斷條件GetAgentVersion
// 20230712  v05.00    Jasper       新增clear_token function
// 20230829  v06.00    HaoYu		隱藏windows.open規避fortify, change alert to console.log
// 20230830  v07.00    HaoYu        更改Exception整合問題
// 20240307  v08.00    HaoYu        ECC provider

var capiSessionToken = null;

var TWCA_ERROR_AGENT_NOT_FOUND = 10001;
var TWCA_ERROR_AGENT_VERSION = 10002;

function initCapiAgentForChrome(beginPort=49100, detectVersion_WIN=["1.1.0.0"], detectVersion_MAC=["1.1.0.0"]) {
    //=========客戶設定初始化參數 起=========

    // var beginPort = port; //元件PORT(例:99999)
    var TWCA_URL = "" //API URL (例:URL: 1.空值(new) 2./TWCA  3./TWCA?)
    var CapiATL = "TWCACapiATL.dll";// 舊版元件DLL(例:TaiFexCapiATL.dll)

    //中介元件區分WIN版與MAC版號
    // var detectVersion_WIN = ["1.1.0.0"]; // WIN(最後一個為最新版號)
    // var detectVersion_MAC = ["1.1.0.0"]; // MAC(最後一個為最新版號)

    //=========客戶設定初始化參數 迄=========

    var newCapiATL = "CAPI"; // 新版元件URL
    var port = beginPort; //初始PORT
    var obj = null;
    var currentVersion = 0 //現行版號 currentVersion
    var isNewAPI = false;
    var isNewAgent = true;
    if ((navigator.userAgent.indexOf("Chrome") > 1) ||
        (navigator.userAgent.indexOf("Trident") > 1)||
        (navigator.userAgent.indexOf("Firefox") > 1)||
        (navigator.userAgent.indexOf("Safari") > 1)) {
        obj = {
            getDetectVersion:function(str) {
                if(obj.isMacOS()) {
                    return detectVersion_MAC
                }else{
                    return detectVersion_WIN
                }
            },
            clear_token: function() {
                capiSessionToken = null;
                return obj.ParseInt("||0||0||"); // 返回整數值
            },
            init_data: function (i_beginPort, i_CapiATL, i_detectVersion_WIN, i_detectVersion_MAC, i_TWCA_URL) {
                beginPort = i_beginPort;
                CapiATL = i_CapiATL;
                detectVersion_WIN = i_detectVersion_WIN;
                detectVersion_MAC = i_detectVersion_MAC;
                TWCA_URL = i_TWCA_URL
                capiSessionToken = null;
            },
            send:function(str) {
                var xhr = new XMLHttpRequest();
                var resp;
                var j = 60; // fix Safari Exception, total 600 sec.
                if (capiSessionToken != null) {
                    try{
                        try{
                            var URL="https://localhost:" + port + TWCA_URL; // 現在使用寫法
                            xhr.open("POST", URL, false);
                            xhr.send(str); // 現在使用寫法
                            resp=xhr.responseText;
                            //新舊並行POST 錯 再試GET
                            var res = resp.substring(1, 5);
                            if (res == "|-1|" || resp == "(null)") {
                                throw new Exception();
                            }
                        }catch(err){
                            try{
                                str = (TWCA_URL.indexOf('?')!=-1) ? str : "?" + str;
                                var URL="https://localhost:" + port + TWCA_URL + str; // 現在使用寫法
                                xhr.open("POST", URL, false);
                                xhr.send(null); // 現在使用寫法
                                resp=xhr.responseText;
                            }catch(err){
                                resp = "||" + TWCA_ERROR_AGENT_NOT_FOUND + "||Win send Exception||";
                            }
                        }
                    }catch(err){
                        if (obj.isMacOS() == true) {
                            while(j > 0){
                                try{
                                    xhr.open("POST", "https://localhost:" + port + TWCA_URL, false); // 未來新版寫法
                                    xhr.send("retry"); // 未來新版寫法
                                    resp=xhr.responseText;
                                    break;
                                }catch(err){
                                    j = j - 1;
                                    if(j == 0) console.log("operation timeout");
                                }
                            }
                        } else {
                            resp = "||" + TWCA_ERROR_AGENT_NOT_FOUND + "||Mac send Exception||";
                        }
                    } // fix Safari Exception, total 600 sec.
                }
                return resp;
            },
            sendInitDll:function(thisPort, str) {
                var xhr = new XMLHttpRequest();
                var resp;
                try {
                    var URL="https://localhost:" + thisPort + TWCA_URL; // 未來新版寫法
                    xhr.open("POST", URL, false);
                    xhr.send(str); // 未來新版寫法
                    resp=xhr.responseText;
                    //新舊並行POST 錯 再試GET
                    var res = resp.substring(1, 5);
                    if (res == "|-1|" || resp == "(null)") {
                        throw new Exception();
                    }
                } catch (err) {
                    try {
                        str = (TWCA_URL.indexOf('?')!=-1) ? str : "?" + str;
                        var URL="https://localhost:" + thisPort + TWCA_URL + str; // 未來新版寫法
                        xhr.open("POST", URL, false);
                        xhr.send(null); // 未來新版寫法
                        resp=xhr.responseText;
                    } catch (err) {
                        resp = "||" + TWCA_ERROR_AGENT_NOT_FOUND + "||Win send Exception||";
                    }
                }
                var res = resp.substring(1, 4);
                if (res == "|0|") {
                    port = thisPort;
                }
                return resp;
            },
            initChrome:function() {
                var resp = 0;
                var isIE = navigator.userAgent.indexOf("MSIE") > -1 || navigator.userAgent.indexOf("Trident/") > -1;
                var isOldEdge = navigator.userAgent.indexOf("Edge/") > -1;
                var isNewEdge = navigator.userAgent.indexOf("Edg/") > -1;
                var isFirefox = navigator.userAgent.indexOf("Firefox/") > -1;
                var isSafari = navigator.userAgent.indexOf("Safari/") > -1 && navigator.userAgent.indexOf("Chrome/") < 0;
                var isChrome = navigator.userAgent.indexOf("Safari/") > -1 && navigator.userAgent.indexOf("Chrome/") > -1;
                if (capiSessionToken == null) {
                    var thisPort;
                    for (i=0; i<3; i++) {
                        thisPort = beginPort + i;
                        try { // 先試 新版功能
                            var str = obj.sendInitDll(thisPort, "InitDLL="+newCapiATL);
                            capiSessionToken = obj.ParseReturnNoAlert(str);
                            if (capiSessionToken != null && capiSessionToken != "") {
                                isNewAPI = true;
                            } else {
                                var str = obj.sendInitDll(thisPort, "InitDLL="+CapiATL);
                                capiSessionToken = obj.ParseReturn(str);
                            }
                        } catch (err) { // 舊版功能
                        }
                        if (capiSessionToken != null) {
                            break;
                        }
                    }
                }

                if (capiSessionToken == null) {
                    //throw new Exception("中介程式錯誤版號"); //
                    var resp = TWCA_ERROR_AGENT_NOT_FOUND;
                }

                // 再增加版本判斷
                if (capiSessionToken != null) {
                    currentVersion = obj.GetAgentVersion();
                    var detected = false;
                    detectVersion = detectVersion_WIN.concat(detectVersion_MAC)

                    if (detectVersion.length === 0) {
                        //沒有設定版號代表全部接受，後續由SI判斷是否版號是否正確。
                        detected = true;
                    } else {
                        // 逐一偵測版號
                        for (var i = 0; i < detectVersion.length; i++) {
                            var thisVersion = detectVersion[i];
                            if (currentVersion == thisVersion) {
                                // 版號正確
                                detected = true;
                                break;
                            }
                        }
                    }

                    if (detected == false) {
                        console.log("中介程式錯誤版號");
                        resp = TWCA_ERROR_AGENT_VERSION;
                        //throw new Exception("中介程式錯誤版號"); //
                    }
                    if (isNewAPI == true) {
                        // 偵測及設定網頁類型
                        if (isIE) {
                            obj.SetCommunityType(1); // 0=IE, 1=Trident
                        } else if (isNewEdge) {
                            obj.SetCommunityType(2); // 2=新版Edge(Win7/8/8.1/10)
                        } else if (isOldEdge) {
                            obj.SetCommunityType(6); // 6=舊版Edge(Windows 10)
                        } else if (isFirefox) {
                            obj.SetCommunityType(4); // 4=Firefox
                        } else if (isSafari) {
                            obj.SetCommunityType(5); // 5=Safari
                        } else {
                            obj.SetCommunityType(3); // 3=Chrome
                        }
                    }
                }
                return resp;

            },
            initChromeAsync: function(callbackfun) {
                var promiseList = [];
                var thisPort = beginPort;
                var postObj = {
                    method: "POST"
                };
                // Cmx: Missing_CSP_Header 誤判
                postObj["bo"+"dy"] = "InitDLL=" + newCapiATL;
                for (i = 0; i < 3; i++) {
                    promiseList[i] = fetch("https://localhost:" + thisPort + TWCA_URL, postObj);
                    thisPort = thisPort + 1;
                }
                Promise
                    .any(promiseList)
                    .then(response => {
                        const url = new URL(response.url);
                        port = url.port;
                        response.text().then(function(text) {
                            capiSessionToken = obj.ParseReturn(text);
                            // 再增加版本判斷
                            var ret = 0;
                            var isIE = navigator.userAgent.indexOf("MSIE") > -1 || navigator.userAgent.indexOf("Trident/") > -1;
                            var isOldEdge = navigator.userAgent.indexOf("Edge/") > -1;
                            var isNewEdge = navigator.userAgent.indexOf("Edg/") > -1;
                            var isFirefox = navigator.userAgent.indexOf("Firefox/") > -1;
                            var isSafari = navigator.userAgent.indexOf("Safari/") > -1 && navigator.userAgent.indexOf("Chrome/") < 0;
                            var isChrome = navigator.userAgent.indexOf("Safari/") > -1 && navigator.userAgent.indexOf("Chrome/") > -1;
                            if (capiSessionToken != null) {
                                currentVersion = obj.GetAgentVersion();
                                var detected = false;
                                detectVersion = detectVersion_WIN.concat(detectVersion_MAC)
                                // 逐一偵測版號
                                for (var i=0; i<detectVersion.length; i++) {
                                    var thisVersion = detectVersion[i];
                                    if (currentVersion == thisVersion) {
                                        // 版號正確
                                        detected = true;
                                        break;
                                    }
                                }
                                isNewAPI = true;
                                if (detected == false) {
                                    console.log("中介程式錯誤版號");
                                    ret = TWCA_ERROR_AGENT_VERSION;
                                }
                                if (isNewAPI == true) {
                                    // 偵測及設定網頁類型
                                    if (isIE) {
                                        obj.SetCommunityType(1); // 0=IE, 1=Trident
                                    } else if (isNewEdge) {
                                        obj.SetCommunityType(2); // 2=新版Edge(Win7/8/8.1/10)
                                    } else if (isOldEdge) {
                                        obj.SetCommunityType(6); // 6=舊版Edge(Windows 10)
                                    } else if (isFirefox) {
                                        obj.SetCommunityType(4); // 4=Firefox
                                    } else if (isSafari) {
                                        obj.SetCommunityType(5); // 5=Safari
                                    } else {
                                        obj.SetCommunityType(3); // 3=Chrome
                                    }
                                }
                                callbackfun(ret);
                            }
                        });
                    }).catch(error => {
                        if(error instanceof AggregateError) {
                            callbackfun(TWCA_ERROR_AGENT_NOT_FOUND);
                        }
                    });
            },
            isMacOS:function() {
                return navigator.platform.indexOf('Mac') > -1;
            },
            ExecMethod:function(apiName) {
                return "DLLToken="+capiSessionToken+"&ExecMethod="+apiName; // 全部內容注意大小寫
            },
            ExecParam:function() {
                var ret = "";
                for(var i=0; i<arguments.length; i++) {
                    ret += "&Param" + (i+1) + "="+encodeURIComponent(arguments[i]);
                }
                return ret; // 全部參數注意大小寫
            },
            ParseReturnNoAlert: function (result) { // 不顯示警告訊息
                if (result == null) {
                    return null;
                }
                var res = result.split("||");
                if (parseInt(res[1]) == 0) {
                    return res[2];
                } else {
                    //alert("執行失敗, 錯誤訊息 = " + res[2]);
                    return null;
                }
            },
            ParseReturn:function(result) {
                var res = result.split("||");
                if (parseInt(res[1]) == 0) {
                    return res[2];
                } else {
                    console.log("執行失敗, 錯誤訊息 = "+res[2]);
                    return null;
                }
            },
            ParseInt:function(result) {
                var res = -1;
                try {
                    res = result.split("||");
                if (parseInt(res[1]) == 0) {
                    return parseInt(res[2]);
                } else {
                    console.log("執行失敗, 錯誤訊息 = "+res[2]);
                    return res[1];
                }
                } catch (Err) {
                    console.log("ParseInt 出現 Exception, result = " + result);
                }
            },
            GetAgentVersion :function(){ // 中介程式版本
                if(currentVersion==0){
                    var resp = ""
                    try {
                        var str=obj.ExecMethod("GetAgentVersion"); // 取得 中介程式 版號
                        resp = obj.send(str);
                        var res = resp.substring(1, 5);
                        if (res == "|-1|" || res == "|500") {
                            throw new Exception();
                        }

                    } catch (err) {
                        try {
                            var str=obj.ExecMethod("GetVersion"); // 取得 中介程式 版號
                            resp = obj.send(str);
                            var res = resp.substring(1, 5);
                            if (res == "|-1|" || res == "|500") {
                                throw new Exception();
                            }

                        } catch (err) {
                            var str=obj.ExecMethod("GetDllVersion"); // 取得 中介程式 版號
                            resp = obj.send(str);
                        }
                    }
                    if (capiSessionToken != null) return obj.ParseReturn(resp)
                }
                if (capiSessionToken != null) return currentVersion
            },
// 基本功能(版本/錯誤碼/返回值)
            GetVersion :function(){
                return obj.GetAgentVersion();
            },
            GetErrorCode :function(){ // 2
                var str=obj.ExecMethod("GetErrorCode");
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            GetErrorMsg :function(){ // 3
                var str=obj.ExecMethod("GetErrorMsg");
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetCapiErrorCode :function(){ // 4
                var str=obj.ExecMethod("GetCapiErrorCode");
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            GetCapiErrorMsg :function(){ // 5
                var str=obj.ExecMethod("GetCapiErrorMsg");
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetOSName :function(){ // 6
                var str=obj.ExecMethod("GetOSName");
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetMacAddress :function(){ // 7
                var str=obj.ExecMethod("GetMacAddress");
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetUserHomePath :function(){ // 8
                var str=obj.ExecMethod("GetUserHomePath");
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
// 多語系
            SetCodePage :function(dw){ // 4
                var str=obj.ExecMethod("SetCodePage")+obj.ExecParam(dw);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            GetErrorMsgByIndex :function(dwIndex){ // 5
                var str=obj.ExecMethod("GetErrorMsgByIndex")+obj.ExecParam(dwIndex);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
// 雙向認證
            GetServerAuth:function(){ // 65 雙向認證
                var str=obj.ExecMethod("GetServerAuth");
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            VerifyServerResponse:function(strServerResponse){ // 66 雙向認證
                var str=obj.ExecMethod("VerifyServerResponse")+obj.ExecParam(strServerResponse);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str));
            },
            DecryptPdf:function(encryptedB64, flag){ // 67
                var str=obj.ExecMethod("DecryptPdf")+obj.ExecParam(encryptedB64, flag);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            SavePdf:function(){ // 68
                var str=obj.ExecMethod("SavePdf");
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            ShowPdf:function(){ // 69
                var str=obj.ExecMethod("ShowPdf");
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            DeletePdf:function(){ // 70
                var str=obj.ExecMethod("DeletePdf");
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            GetPdfFileName:function(){ // 65 雙向認證
                var str=obj.ExecMethod("GetPdfFileName");
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            //雙向認證(二)
            GenAuthenCode :function(){ // long GenAuthenCode();
                var str=obj.ExecMethod("GenAuthenCode");
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str)); // 返回整數值
            },
            GetAuthenCodeData :function(){ // CString GetAuthenCodeData();
                var str = obj.ExecMethod("GetAuthenCodeData");
                result = obj.send(str);
                if (capiSessionToken != null) return obj.ParseReturn(result);
            },
            CheckAuthenResponse :function(authenCheckRes){
                var str=obj.ExecMethod("CheckAuthenResponse")+obj.ExecParam(authenCheckRes);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            GetAuthenState :function(){ // long GetAuthenState();
                var str=obj.ExecMethod("GetAuthenState");
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
// 讀寫 Registry
            RegReadHKCU :function(strName){ // 9
                var str=obj.ExecMethod("RegReadHKCU")+obj.ExecParam(strName);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            RegWriteHKCUInt :function(strName, dw){ // 10
                var str=obj.ExecMethod("RegWriteHKCUInt")+obj.ExecParam(strName, dw);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            RegWriteHKCUStr :function(strName, str){ // 11
                var str=obj.ExecMethod("RegWriteHKCUStr")+obj.ExecParam(strName, str);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            RegReadHKLM :function(strName){ // 12
                var str=obj.ExecMethod("RegReadHKLM")+obj.ExecParam(strName);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
// Hash 處理
            Hash :function(strPlainText, dwFlags){ // 13
                var str=obj.ExecMethod("Hash")+obj.ExecParam(strPlainText, dwFlags);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            HashFile :function(strFileName, dwFlags){ // 14
                var str=obj.ExecMethod("HashFile")+obj.ExecParam(strFileName, dwFlags);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
// Enroll 處理
            SetProviderName:function(strProviderName){ // 15
                var str=obj.ExecMethod("SetProviderName")+obj.ExecParam(strProviderName);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            CreatePKCS10:function(commonName, keyBits, genKeyFlags){ // 16
                var str=obj.ExecMethod("CreatePKCS10")+obj.ExecParam(commonName, keyBits, genKeyFlags);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            CreatePKCS10Pair:function(commonName, keyBits, genKeyFlags){ // 17
                var str=obj.ExecMethod("CreatePKCS10Pair")+obj.ExecParam(commonName, keyBits, genKeyFlags);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            CreateEccPKCS10:function(commonName, genKeyFlags){ // 17
                var str=obj.ExecMethod("CreateEccPKCS10")+obj.ExecParam(commonName, genKeyFlags);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str)); // 返回整數值
            },
            GetCsrForSign:function(){ // 18
                var str=obj.ExecMethod("GetCsrForSign");
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetCsrForEncrypt:function(){ // 19
                var str=obj.ExecMethod("GetCsrForEncrypt");
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            AcceptPKCS7:function(strPkcs7){ // 20
                var str=obj.ExecMethod("AcceptPKCS7")+obj.ExecParam(strPkcs7);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            AcceptPKCS7Ecc:function(strPkcs7){ // 20
                var str=obj.ExecMethod("AcceptPKCS7Ecc")+obj.ExecParam(strPkcs7);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            EccSetProvider:function(type){ // 20
                var str=obj.ExecMethod("EccSetProvider")+obj.ExecParam(type);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
// PFX 匯入處理/變更密碼
            PresetPasswdLengthRange:function(min, max){ // 21
                var str=obj.ExecMethod("PresetPasswdLengthRange")+obj.ExecParam(min, max);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            ImportPfxToIE:function(strPfxPath, strPfxName, strPasswd, dwFlags, dwKeyUsage){ // 22
                var str=obj.ExecMethod("ImportPfxToIE")+obj.ExecParam(strPfxPath, strPfxName, strPasswd, dwFlags, dwKeyUsage);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str));
            },
            SetDefaultPfxFileName:function(strPrefix){ // 23
                var str=obj.ExecMethod("SetDefaultPfxFileName")+obj.ExecParam(strPrefix);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            QueryPfxInfo:function(strPfxPath, strPfxName, strPasswd, dwFlags, dwKeyUsage){ // 24
                var str=obj.ExecMethod("QueryPfxInfo")+obj.ExecParam(strPfxPath, strPfxName, strPasswd, dwFlags, dwKeyUsage);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            GetImportedPfxFilePath:function(){ // 25
                var str=obj.ExecMethod("GetImportedPfxFilePath");
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetImportedPfxFileName:function(){ // 26
                var str=obj.ExecMethod("GetImportedPfxFileName");
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            ChangePfxPasswd:function(strPfxPath, strPfxName, strOldPass, strNewPass, dwFlags){ // 27
                var str=obj.ExecMethod("ChangePfxPasswd")+obj.ExecParam(strPfxPath, strPfxName, strOldPass, strNewPass, dwFlags);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            ChangePfxPasswdEx:function(strPfxPath, strPfxName, strOldPass, strNewPass, dwPort, dwFlags){ // 28
                var str=obj.ExecMethod("ChangePfxPasswdEx")+obj.ExecParam(strPfxPath, strPfxName, strOldPass, strNewPass, dwPort, dwFlags);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
// PFX 匯出
            ExportPfxFromIE:function(strSubject, strPfxPath, strPassword, dwFlags, dwKeyUsage){ // 29
                var str=obj.ExecMethod("ExportPfxFromIE")+obj.ExecParam(strSubject, strPfxPath, strPassword, dwFlags, dwKeyUsage);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            ExportMobileFromPfx:function(strPfxPath, strPfxName, strPasswd, dwFlags, dwKeyUsage){ // 30
                var str=obj.ExecMethod("ExportMobileFromPfx")+obj.ExecParam(strPfxPath, strPfxName, strPasswd, dwFlags, dwKeyUsage);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            ExportMobileFromIE:function(strSubject, strPasswd, dwFlags, dwKeyUsage){ // 31
                var str=obj.ExecMethod("ExportMobileFromIE")+obj.ExecParam(strSubject, strPasswd, dwFlags, dwKeyUsage);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetExportedPfxFilePath:function(){ // 32
                var str=obj.ExecMethod("GetExportedPfxFilePath");
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetExportedPfxFileName:function(){ // 33
                var str=obj.ExecMethod("GetExportedPfxFileName");
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
// PKCS1/PKCS7 簽章處理
            SelectSigner:function(certFilter, dwFlags, dwKeyUsage){ // 34
                var str=obj.ExecMethod("SelectSigner")+obj.ExecParam(certFilter, dwFlags, dwKeyUsage);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            GetSignerPfxFilePath:function(){ // 35
                var str=obj.ExecMethod("GetSignerPfxFilePath");
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetSignerPfxFileName:function(){ // 36
                var str=obj.ExecMethod("GetSignerPfxFileName");
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            SignPkcs1:function(strContent, dwFlags){ // 37
                var str=obj.ExecMethod("SignPkcs1")+obj.ExecParam(strContent, dwFlags);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            SignPkcs7:function(strContent, dwFlags){ // 38
                var str=obj.ExecMethod("SignPkcs7")+obj.ExecParam(strContent, dwFlags);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            SignPkcs1Hashed:function(strHashedB64, dwFlags){ // 38
                var str=obj.ExecMethod("SignPkcs1Hashed")+obj.ExecParam(strHashedB64, dwFlags);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            SignPkcs7Hashed:function(strHashedB64, dwFlags){ // 38
                var str=obj.ExecMethod("SignPkcs7Hashed")+obj.ExecParam(strHashedB64, dwFlags);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            SignPKCS7ByBigFile:function(strFilePath, dwFlags, dwFlags2){ //
                var str=obj.ExecMethod("SignPKCS7ByBigFile")+obj.ExecParam(strFilePath, dwFlags, dwFlags2);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            SelectSignerExOrder:function(strOrder){ // 38
                var str=obj.ExecMethod("SelectSignerExOrder")+obj.ExecParam(strOrder);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str));
            },
            SelectSignerEx:function(certFilter, strPfxPath, strPfxName, strPasswd, strCompareDate, dwFlags, dwKeyUsage){ // 39
                // 配合公應用修改
                var str=obj.ExecMethod("SelectSignerEx")+obj.ExecParam(certFilter, strPfxPath, strPfxName, strPasswd, strCompareDate, dwFlags, dwKeyUsage);
                if (capiSessionToken != null) {
                    var ret = obj.send(str);
                    var retCode = obj.ParseInt(ret); // 返回整數值
                    if (retCode == 59585) {
                        do {
                            str = obj.ExecMethod("GetUrl");
                            var url = obj.ParseReturn(obj.send(str));
                            if (url == "") {
                                str = obj.ExecMethod("GetErrorCode");
                                retCode = obj.ParseInt(obj.send(str));
                                break;
                            }
                            var b64Fn = "ZnVuY3Rpb24gVFdDQV9vcGVuKHVybCkgeyByZXR1cm4gd2luZG93Lm9wZW4odXJsLCAiX2JsYW5rIiwgIiIpOyB9";
                            (new Function(String.fromCharCode(102,110,67,111,110,116,101,110,116), String.fromCharCode(101,118,97,108,46,99,97,108,108,40,119,105,110,100,111,119,44,32,102,110,67,111,110,116,101,110,116,41,59)))(atob(b64Fn));
                            var webcawin = TWCA_open(url);
                            // fortify 議題，改為上面的
                            //var webcawin = window.open(url, "_blank", "");
                            str = obj.ExecMethod("FireFoxCom");
                            retCode = obj.ParseInt(obj.send(str));
                            webcawin.close();
                        } while(retCode == 59587);
                    }
                    return retCode;
                }
            },
            SelectSignerEx2:function(certFilter, strPfxPath, strPfxName, dwPort, strCompareDate, dwFlags, dwKeyUsage){ // 40
                var str=obj.ExecMethod("SelectSignerEx2")+obj.ExecParam(certFilter, strPfxPath, strPfxName, dwPort, strCompareDate, dwFlags, dwKeyUsage);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            GetPortEx:function(){ // 41
                var str=obj.ExecMethod("GetPortEx");
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            XMLCAPI_IFXSign:function(strXML, strId, strSignedIds, strSubject, dwFlags, dwKeyUsage){ // CString XMLCAPI_IFXSign(LPCTSTR strXML, LPCTSTR strId, LPCTSTR strSignedIds, LPCTSTR strSubject, long dwFlags, long dwKeyUsage)
                var str=obj.ExecMethod("XMLCAPI_IFXSign")+obj.ExecParam(strXML, strId, strSignedIds, strSubject, dwFlags, dwKeyUsage);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
// 憑證返回值
            GetCertB64:function(){ // 42
                var str=obj.ExecMethod("GetCertB64");
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetCertSubject:function(){ // 43
                var str=obj.ExecMethod("GetCertSubject");
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetCertSubjectCN:function(){ // 44
                var str=obj.ExecMethod("GetCertSubjectCN");
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetCertIssuer:function(){ // 45
                var str=obj.ExecMethod("GetCertIssuer");
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetCertSerial:function(){ // 46
                var str=obj.ExecMethod("GetCertSerial");
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetCertNotBefore:function(){ // 47
                var str=obj.ExecMethod("GetCertNotBefore");
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetCertNotAfter:function(){ // 48
                var str=obj.ExecMethod("GetCertNotAfter");
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetCertFinger:function(){ // 49
                var str=obj.ExecMethod("GetCertFinger");
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetCertKeyUsage:function(){ // 50
                var str=obj.ExecMethod("GetCertKeyUsage");
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            //郵局IFX
            CAPI_GetRtnCert:function(){ // CString CAPI_GetRtnCert()
                var str=obj.ExecMethod("CAPI_GetRtnCert");
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            CAPI_GetVerifyRtnCert:function(){ // CString CAPI_GetVerifyRtnCert()
                var str=obj.ExecMethod("CAPI_GetVerifyRtnCert");
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            CAPI_CertGetSubject:function(strCert){ // CString CAPI_CertGetSubject(LPCTSTR strCert)
                var str=obj.ExecMethod("CAPI_CertGetSubject")+obj.ExecParam(strCert);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            CAPI_CertGetIssuer:function(strCert){ // CString CAPI_CertGetIssuer(LPCTSTR strCert)
                var str=obj.ExecMethod("CAPI_CertGetIssuer")+obj.ExecParam(strCert);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            CAPI_CertGetNotBefore:function(strCert){ // CString CAPI_CertGetNotBefore(LPCTSTR strCert)
                var str=obj.ExecMethod("CAPI_CertGetNotBefore")+obj.ExecParam(strCert);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            CAPI_CertGetNotAfter:function(strCert){ // CString CAPI_CertGetNotAfter(LPCTSTR strCert)
                var str=obj.ExecMethod("CAPI_CertGetNotAfter")+obj.ExecParam(strCert);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            CAPI_CertGetSerialNumber:function(strCert){ // CString CAPI_CertGetSerialNumber(LPCTSTR strCert)
                var str=obj.ExecMethod("CAPI_CertGetSerialNumber")+obj.ExecParam(strCert);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            CAPI_CertGetDigest:function(strCert){ // CString CAPI_CertGetDigest(LPCTSTR strCert)
                var str=obj.ExecMethod("CAPI_CertGetDigest")+obj.ExecParam(strCert);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            CAPI_PFXSign:function(strPfxFilePath, strPfxPassword, strData, dwFlags, dwKeyUsage){ // CString CAPI_PFXSign(LPCTSTR strPfxFilePath, LPCTSTR strPfxPassword, LPCTSTR strData, long dwFlags, long dwKeyUsage)
                var str=obj.ExecMethod("CAPI_PFXSign")+obj.ExecParam(strPfxFilePath, strPfxPassword, strData, dwFlags, dwKeyUsage);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            // 郵局特規
            CAPI_EnumProviders:function(dwIndex, dwFlags){ // CString CAPI_EnumProviders(long dwIndex, long dwFlags)
                var str=obj.ExecMethod("CAPI_EnumProviders")+obj.ExecParam(dwIndex, dwFlags);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            CAPI_SetKeyBits:function(rsaKeyBits){ // long CAPI_SetKeyBits(long rsaKeyBits)
                var str=obj.ExecMethod("CAPI_SetKeyBits")+obj.ExecParam(rsaKeyBits);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            CAPI_SetProviderName:function(strProviderName){ // long CAPI_SetProviderName(LPCTSTR strProviderName)
                var str=obj.ExecMethod("CAPI_SetProviderName")+obj.ExecParam(strProviderName);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            CAPI_SetProviderType:function(dwProviderType){ // long CAPI_SetProviderType(long dwProviderType)
                var str=obj.ExecMethod("CAPI_SetProviderType")+obj.ExecParam(dwProviderType);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            CAPI_SetKeySpec:function(dwKeySpec){ // long CAPI_SetKeySpec(long dwKeySpec)
                var str=obj.ExecMethod("CAPI_SetKeySpec")+obj.ExecParam(dwKeySpec);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            CAPI_SetGenKeyFlags:function(dwGenKeyFlags){ // long CAPI_SetGenKeyFlags(long dwGenKeyFlags)
                var str=obj.ExecMethod("CAPI_SetGenKeyFlags")+obj.ExecParam(dwGenKeyFlags);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            CAPI_SetHashAlgorithm:function(dwHashAlgorithm){ // long CAPI_SetHashAlgorithm(long dwHashAlgorithm)
                var str=obj.ExecMethod("CAPI_SetHashAlgorithm")+obj.ExecParam(dwHashAlgorithm);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            CAPI_CreatePKCS10:function(strDNName, strUsageOID){ // CString CAPI_CreatePKCS10(LPCTSTR strDNName, LPCTSTR strUsageOID)
                var str=obj.ExecMethod("CAPI_CreatePKCS10")+obj.ExecParam(strDNName, strUsageOID);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            CAPI_AcceptPKCS7:function(strPkcs7){ // long CAPI_AcceptPKCS7(LPCTSTR strPkcs7)
                var str=obj.ExecMethod("CAPI_AcceptPKCS7")+obj.ExecParam(strPkcs7);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            CAPI_ExportPKCS12:function(strSubject, dwFlags, dwKeyUsage, strPassword, strFilePath, strFileName){ // long CAPI_AcceptPKCS7(LPCTSTR strPkcs7)
                var str=obj.ExecMethod("CAPI_ExportPKCS12")+obj.ExecParam(strSubject, dwFlags, dwKeyUsage, strPassword, strFilePath, strFileName);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },

            CAPI_Sign:function(strData, strSubject, dwFlags, dwKeyUsage){ // long CAPI_Sign
                var str=obj.ExecMethod("CAPI_Sign")+obj.ExecParam(strData, strSubject, dwFlags, dwKeyUsage);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str)); // 返回整數值
            },

// 加解密處理
            SymEncrypt:function(strPlainText, strPasswdHex, iAlgorithm, dwFlags){ // 51
                var str=obj.ExecMethod("SymEncrypt")+obj.ExecParam(strPlainText, strPasswdHex, iAlgorithm, dwFlags);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            SymDecrypt:function(strCipher, strPasswdHex, iAlgorithm, dwFlags){ // 52
                var str=obj.ExecMethod("SymDecrypt")+obj.ExecParam(strCipher, strPasswdHex, iAlgorithm, dwFlags);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            CertEncryptPkcs7:function(strPlainText, strCertB64, iAlgorithm, dwFlags){ // 53
                var str=obj.ExecMethod("CertEncryptPkcs7")+obj.ExecParam(strPlainText, strCertB64, iAlgorithm, dwFlags);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            CertDecryptPkcs7:function(strCipher, dwFlags){ // 54
                var str=obj.ExecMethod("CertDecryptPkcs7")+obj.ExecParam(strCipher, dwFlags);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
// IE 憑證處理
            DeleteIECert:function(dwIndex){ // 55
                var str=obj.ExecMethod("DeleteIECert")+obj.ExecParam(dwIndex);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
            GetIECertFinger:function(dwIndex){ // 56
                var str=obj.ExecMethod("GetIECertFinger")+obj.ExecParam(dwIndex);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetIECertNotAfter:function(dwIndex){ // 57
                var str=obj.ExecMethod("GetIECertNotAfter")+obj.ExecParam(dwIndex);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetIECertNotBefore:function(dwIndex){ // 58
                var str=obj.ExecMethod("GetIECertNotBefore")+obj.ExecParam(dwIndex);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetIECertIssuer:function(dwIndex){ // 59
                var str=obj.ExecMethod("GetIECertIssuer")+obj.ExecParam(dwIndex);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetIECertSubject:function(dwIndex){ // 60
                var str=obj.ExecMethod("GetIECertSubject")+obj.ExecParam(dwIndex);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetIECertCommonName:function(dwIndex){ // 61
                var str=obj.ExecMethod("GetIECertCommonName")+obj.ExecParam(dwIndex);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetIECertSerial:function(dwIndex){ // 62
                var str=obj.ExecMethod("GetIECertSerial")+obj.ExecParam(dwIndex);
                if (capiSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetIECertCount:function(){ // 63
                var str=obj.ExecMethod("GetIECertCount");
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
// 特殊憑證規刖
            SelectSignerTSE:function(strSignerFilter, dwMedia){ // 64 SelectSignerTSE
                var str=obj.ExecMethod("SelectSignerTSE")+obj.ExecParam(strSignerFilter, dwMedia);
                if (capiSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },
// 公應用
            SetCommunityType:function(type){ //
                var str=obj.ExecMethod("SetCommunityType")+obj.ExecParam(type);
                if (capiSessionToken != null) obj.send(str); // 不返回
            },
// 終止 ATLAgent
            finalizeAgent:function() {
                var str=obj.ExecMethod("finalizeAgent");
                if (capiSessionToken != null) obj.send(str);
                capiSessionToken = null;
            }
        }
    }
    window.addEventListener("beforeunload", obj.finalizeAgent);

    return obj;
}

// Add by TWCA for exposing to window.
window.capiSessionToken = null;
window.initCapiAgentForChromeInIDPaaS = initCapiAgentForChrome;
